import React, { FC, useEffect, useState } from 'react';
import { T2 } from '../../styles/titles';
import LoadingOverlay from '../../components/LoadingOverlay';
import { LiveTable } from './components/liveTable/liveTable';
import PaymentStatementServices from './services/PaymentStatementServices';
import { Container } from './styles';
import {FormFilter} from './components/filter/filter';
import {Button} from '../terminaisPhoebus/styles';
import {SettlementsTableData} from './types';
import { can, PortalPermissions } from "../../config/permissions";

const PaymentStatement: FC = () => {
  const paymentStatementServices = new PaymentStatementServices();
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState<any>(null);
  const [tableData, setTableData] = useState<SettlementsTableData | null>(null);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      return await paymentStatementServices.getPayments(currentPage, pageSize, filterData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async (filterData: any) => {
    try {
      setIsLoading(true);
      await paymentStatementServices.getPaymentsXlsxDownload('xls', filterData);
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData().then(response => {
        setTableData({ records: response.items ?? [], count: response.rowCount ?? 0 });
      });
    }
  }, [filterData, pageSize, currentPage]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} />
      <T2>Extrato de recebimento</T2>
      <FormFilter getFilters={(data) => setFilterData(data)} />

      {can(PortalPermissions.financeiro.extrato.exportar) && (
        <Button
          onClick={() => {handleDownload(filterData)}}
          style={{
            marginBottom: '25px',
            marginRight: '24px',
            width: '150px',
            alignSelf: 'start'
          }}>
          Download XLSX
        </Button>
      )}

      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize} />
      )}
    </Container>
  )
}

export default PaymentStatement
